var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pms)?[_c('space-details'),_vm._v(" "),(_vm.photoAlbumDetails.show)?_c('space-photo'):_vm._e(),_vm._v(" "),_c('space-tab')]:_c('no-pms')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a4569e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PartII/SpaceDetails/index.vue
// module id = null
// module chunks = 